<template>
  <div class="p-3 bg-white">
    <div id="EditCallerIdUserFormContainer" class="vs-con-loading__container">
      <shared-caller-id-user-edit
        @editCallerIdUsersSuccess="editCallerIdUsersSuccess"
      ></shared-caller-id-user-edit>

      <div class="text-center">
        <vs-button id="editCallerIdUserButton" class="m-2" color="primary" type="filled" @click.prevent="updateCallerIdUsers">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelEditCallerIdUsers">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

import SharedCallerIdUserEdit from '@/views/Shared/Configuration/CallerId/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Configuration.CallerId.Users.Edit',
  components: {
    SharedCallerIdUserEdit
  },
  mounted () {
    EventBus.$emit('initCallerIdGetFormData', {id: this.$route.params.id})
  },
  methods: {
    updateCallerIdUsers () {
      EventBus.$emit('updateCallerIdUsers')
    },
    editCallerIdUsersSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_configuration_caller_id_table')
      window.close()
    },
    cancelEditCallerIdUsers () {
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
